/*=========================================================================================
 File Name: globalComponents.js
 Description: Here you can register components globally
 ----------------------------------------------------------------------------------------
 Item Name: Vuesax Admin - VueJS Dashboard Admin Template
 Author: Pixinvent
 Author URL: http://www.themeforest.net/user/pixinvent
 ==========================================================================================*/


import Vue             from 'vue';
import vSelect         from 'vue-select';
import VxCard          from './components/vx-card/VxCard.vue';
import VxList          from './components/vx-list/VxList.vue';
import FeatherIcon     from './components/FeatherIcon.vue';
import ElsaVSelect     from './components/ElsaVSelect';
import ElsaVDatepicker from './components/ElsaVDatepicker';
import ElsaVUpload from './components/ElsaVUpload';

import AppIcon       from "./components/_ui/AppIcon";
import AppTag        from "./components/_ui/AppTag";
import AppRow        from "./components/_ui/AppRow";
import AppCol        from "./components/_ui/AppCol";
import AppPanel      from "./components/_ui/AppPanel";
import AppButton     from "./components/_ui/AppButton";
import AppPopup      from "./components/_ui/AppPopup";
import AppInput      from "./components/_ui/AppInput";
import AppAvatar     from "./components/_ui/AppAvatar";
import AppDatepicker from "./components/_ui/AppDatepicker";
import AppTextarea   from "./components/_ui/AppTextarea";
import AppSelect     from "./components/_ui/AppSelect";
import AppDropdown   from "./components/_ui/AppDropdown";
import AppVSelect    from "./components/_ui/AppVSelect";
import AppSwitch     from "./components/_ui/AppSwitch";
import AppRedactor   from "@/components/_ui/AppRedactor";

import InputTwoButtons from "./components/_ui/InputTwoButtons";
import RtTable         from "./components/_ui/responsive-table/RtTable";
import RtTh            from "./components/_ui/responsive-table/RtTh";
import RtTr            from "./components/_ui/responsive-table/RtTr";
import RtTd            from "./components/_ui/responsive-table/RtTd";

Vue.component(VxCard.name, VxCard);
Vue.component(VxList.name, VxList);
Vue.component(FeatherIcon.name, FeatherIcon);

//***REDESIGN***

Vue.component(AppIcon.name, AppIcon);
Vue.component(AppTag.name, AppTag);
Vue.component(AppRow.name, AppRow);
Vue.component(AppCol.name, AppCol);
Vue.component(AppPanel.name, AppPanel);
Vue.component(AppButton.name, AppButton);
Vue.component(AppPopup.name, AppPopup);
Vue.component(AppInput.name, AppInput);
Vue.component(AppAvatar.name, AppAvatar);
Vue.component(AppTextarea.name, AppTextarea);
Vue.component(AppSelect.name, AppSelect);
Vue.component(AppDropdown.name, AppDropdown);
Vue.component(AppDatepicker.name, AppDatepicker);
Vue.component(AppVSelect.name, AppVSelect);
Vue.component(AppSwitch.name, AppSwitch);
Vue.component(AppRedactor.name, AppRedactor);

Vue.component("GridInfiniteScroll", () => import("./components/_ui/ag-table/GridInfiniteScroll"));
Vue.component('AgGridTable', () => import("./components/_ui/ag-table/AgGridTable"));

Vue.component(RtTable.name, RtTable);
Vue.component(RtTh.name, RtTh);
Vue.component(RtTr.name, RtTr);
Vue.component(RtTd.name, RtTd);
Vue.component(InputTwoButtons.name, InputTwoButtons);

// v-select component

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect:      {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
      },
    }),
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
      },
    }),
  },
});

Vue.component('v-select', vSelect);

Vue.component('elsa-v-select', ElsaVSelect);
Vue.component('elsa-v-datepicker', ElsaVDatepicker);
Vue.component('elsa-v-upload', ElsaVUpload);
